<template>
    <section>
        <loading id="spinner" :active="loading" :can-cancel="false" :is-full-page="true"></loading>

        <!-- FORMULÁRIO DE ANÁLISE TÉCNICA -->
        <div class="row">
            <div class="col s12">
                <form id="formAnaliseTecnica" :action="routeSaveData" method="post" class="card-panel">

                    <input name="_token" type="hidden" :value="csrfToken">

                    <div class="row">
                        <h5 class="col s12">Formulário de Análise Técnica</h5>
                    </div>

                    <!-- DADOS DA INSCRIÇÃO -->
                    <div class="row">

                        <div class="col s12">
                            <div class="card-panel">
                                <div class="row">
                                    <h5 class="col s12">Dados da Inscrição</h5>

                                    <Dados_inscricao :acao="inscricao.acao"
                                                     :coordenador="inscricao.usuario"
                                                     :edital="inscricao.edital"
                                                     :quantidade-de-cotas-solicitadas="inscricao.bolsas_extensao? Number(inscricao.bolsas_extensao[0]['quantidade_bolsas_selecionadas']) : inscricao.quantidade_cotas"></Dados_inscricao>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- OBSERVAÇÕES DO ANALISTA -->
                    <div class="row">

                        <div class="col s12">
                            <div class="card-panel">
                                <div class="row">
                                    <h5 class="col s12">Observações</h5>

                                    <At_observacoes v-if="analise_tecnica"
                                                    :all-disabled="modoTela === 'visualizacao'"
                                                    :p-observacoes.sync="analise_tecnica.observacoes"></At_observacoes>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 1. PARCERIAS -->
                    <div class="row">
                        <div class="col s12">
                            <div class="card-panel">
                                <div class="row">
                                    <h5 class="col s12">Parcerias</h5>

                                    <At_parcerias v-if="analise_tecnica"
                                                  :configuracao-de-notas="configuracaoDaAnalise.sua_acao_possui_parcerias_externas"
                                                  :all-disabled="modoTela === 'visualizacao'"
                                                  :p-acao-possui-parcerias-externas.sync="inscricao.acao_possui_parcerias_externas"
                                                  :p-quantidade-parcerias.sync = "inscricao.quantidade_parcerias"
                                                  :p-anexos.sync="inscricao.anexos"
                                                  :p-validacao-selecionada.sync="analise_tecnica.item_acao_possui_parcerias_externas_validacao"
                                                  :p-opcao-selecionada.sync="analise_tecnica.item_acao_possui_parcerias_externas_opcao"
                                                  :p-pontuacao-selecionada.sync="analise_tecnica.item_acao_possui_parcerias_externas_pontuacao"></At_parcerias>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 2. FALTA IMPLEMENTAR A LISTAGEM DE BOLSISTAS DA AÇÃO NO EDITAL ANTERIOR -->
                    <div class="row">
                        <div class="col s12">
                            <div class="card-panel">
                                <div class="row">
                                    <h5 class="col s12">Relatório de bolsistas da ação no edital anterior</h5>

                                    <At_relatorio_bolsista_edital_anterior v-if="analise_tecnica"
                                                                           :all-disabled="modoTela === 'visualizacao'"
                                                                           :configuracao-de-apresentacao-siac="configuracaoDaAnalise.participacao_na_siac_nao_atende"
                                                                           :configuracao-de-relatorio-bolsista="configuracaoDaAnalise.relatorio_de_bolsistas_nao_atende"
                                                                           :p-validacao-relatorio-bolsista.sync="analise_tecnica.item_relatorio_de_bolsistas"
                                                                           :p-validacao-apresentacao-trabalho-siac.sync="analise_tecnica.item_apresentacao_de_trabalho_na_siac"
                                                                           :p-trabalhos-apresentados-na-siac="trabalhosApresentadosNaSiac"
																		   :exibe-opcao-eliminado-para-relatorio-e-siac="exibeOpcaoEliminadoParaRelatorioESiac"
                                                                           :bolsistas-da-acao-no-edital-anterior="bolsistasDaAcaoNoEditalAnterior"></At_relatorio_bolsista_edital_anterior>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 3. PARTICIPAÇÕES NA SIAC -->
                    <div class="row">
                        <div class="col s12">
                            <div class="card-panel">
                                <div class="row">
                                    <h5 class="col s12">Participações na SIAC</h5>

                                    <p v-if="!analise_tecnica || !analise_tecnica.item_participacoes_na_siac"
                                       class="label-info-nao-encontrada">Esse coordenador não possui participações na SIAC!</p>

                                    <At_participacoes_na_siac
                                        v-else
                                        :modo-tela="modoTela"
                                        :configuracao-das-participacoes="configuracaoDaAnalise.participacao_na_siac"
                                        :maximo-de-pontos-para-as-participacoes="configuracaoDaAnalise.participacao_na_siac_maximo_pontos"
                                        :participacoes-na-siac="analise_tecnica.item_participacoes_na_siac"></At_participacoes_na_siac>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 4. QUANTIDADE DE ESTUDANTES ORIENTADOS -->
                    <div class="row">
                        <div class="col s12">
                            <div class="card-panel">
                                <div class="row">
                                    <h5 class="col s12">Estudantes vinculados à ação</h5>

                                    <At_qtd_estudantes_orientados v-if="analise_tecnica"
                                                  :all-disabled="modoTela === 'visualizacao'"
                                                  :configuracao-de-notas="configuracaoDaAnalise.quantidade_estudantes_orientados"
                                                  :p-quantidade-selecionada.sync="analise_tecnica.item_quantidade_estudantes_orientados"
                                                  :p-opcao-selecionada.sync="analise_tecnica.item_quantidade_estudantes_orientados_opcao"
                                                  :p-pontuacao-selecionada.sync="analise_tecnica.item_quantidade_estudantes_orientados_pontuacao"></At_qtd_estudantes_orientados>
                                </div>
                            </div>
                        </div>
                    </div>
					
					<!-- 5. CARGA HORÁRIA DO EVENTO -->
                    <div class="row" v-if="inscricao.acao.modalidade == 'Evento'">
                        <div class="col s12">
                            <div class="card-panel">
                                <div class="row">
                                    <h5 class="col s12">Carga horária do evento</h5>

                                    <At_carga_horaria_evento v-if="analise_tecnica"
                                                                  :all-disabled="modoTela === 'visualizacao'"
                                                                  :configuracao-de-notas="configuracaoDaAnalise.carga_horaria_evento"
                                                                  :p-quantidade-selecionada.sync="analise_tecnica.item_carga_horaria_evento"
                                                                  :p-opcao-selecionada.sync="analise_tecnica.item_carga_horaria_evento_opcao"
                                                                  :p-pontuacao-selecionada.sync="analise_tecnica.item_carga_horaria_evento_pontuacao"></At_carga_horaria_evento>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 5. TEMPO DE EXISTÊNCIA DA AÇÃO -->
                    <!--div class="row">
                        <div class="col s12">
                            <div class="card-panel">
                                <div class="row">
                                    <h5 class="col s12">Tempo de existência da ação</h5>

                                    <At_tempo_existencia_acao v-if="analise_tecnica"
                                                                  :all-disabled="modoTela === 'visualizacao'"
                                                                  :configuracao-de-notas="configuracaoDaAnalise.tempo_existencia_acao"
                                                                  :p-quantidade-selecionada.sync="analise_tecnica.item_tempo_existencia_acao"
                                                                  :p-opcao-selecionada.sync="analise_tecnica.item_tempo_existencia_acao_opcao"
                                                                  :p-pontuacao-selecionada.sync="analise_tecnica.item_tempo_existencia_acao_pontuacao"></At_tempo_existencia_acao>
                                </div>
                            </div>
                        </div>
                    </div-->

                    <!-- 6. RELATÓRIO DA AÇÃO -->
                    <div class="row">
                        <div class="col s12">
                            <div class="card-panel">
                                <div class="row">
                                    <h5 class="col s12">Relatório da ação</h5>

                                    <At_relatorio_acao v-if="analise_tecnica"
                                                  :all-disabled="modoTela === 'visualizacao'"
                                                  :p-validacao-selecionada.sync="analise_tecnica.item_relatorio_acao"></At_relatorio_acao>
                                </div>
                            </div>
                        </div>
                    </div>
					
					<!-- 7. RELATÓRIO DA AÇÃO EXTRAÍDO DO SIGA-->
                    <div class="row">
                        <div class="col s12">
                            <div class="card-panel">
                                <div class="row">
                                    <h5 class="col s12">Relatório da ação extraído do SIGA</h5>

                                    <At_relatorio_acao_siga v-if="analise_tecnica"
                                                  :all-disabled="modoTela === 'visualizacao'"
                                                  :p-validacao-selecionada-siga.sync="analise_tecnica.item_relatorio_acao_siga"
												  :p-itens.sync="inscricao.itens"></At_relatorio_acao_siga>
                                </div>
                            </div>
                        </div>
                    </div>
					
					<!-- 8. QUANTITATIVO DE TURMAS DO CURSO -->
					<div class="col s12" v-if="inscricao.acao.modalidade == 'Curso' && inscricao.turma">
						<div class="card-panel">
							<div class="row">
                                 <h5 class="col s12">Quantidade de turmas ofertadas durante o edital</h5>   
                            </div>

							<div class="row">
								<div class="input-field col s8">
									<p><b>Número de turmas que serão ofertadas durante a vigência do edital:</b></p>
								</div>
								<div class="input-field col s4">
									<input type='number' v-model.number="inscricao.turma.qtde_turmas" readonly>
									</input>
								</div>
							</div>
							<div class="row">
								<div class="input-field col s7">
									<p><b>Carga horária por turma de:</b></p>
								</div>
							</div>
							<div class='row'>
								<div class="input-field col s12 m12 l4 xl4">
									<input type="number" v-model='inscricao.turma.horas_planejamento' readonly>
									</input>
									<label><b>Planejamento</b></label>
								</div>
								<div class="input-field col s12 m12 l4 xl4">
									<input type="number" name="horas_execucao" v-model='inscricao.turma.horas_execucao' readonly>
									</input>
									<label><b>Execução</b></label>
								</div>
								<div class="input-field col s12 m12 l4 xl4">
									<input type="number" v-model='inscricao.turma.horas_avaliacao' readonly>
									</input>
									<label><b>Avaliação</b></label>
								</div>
							</div>

							<div class="row">
								<div class="input-field col s6">
									<input type="text"
										   class="notas"
										   readonly
										   v-model="inscricao.turma.nota_turma[0] + ' h'">
									<label><b>Carga horária total</b>
									</label>
								</div>
								<div class="input-field col s6">
									<input type="number"
										   class="notas"
										   readonly
										   v-model="inscricao.turma.nota_turma[1]">
									<label><b>Nota</b>
									</label>
								</div>
							</div>	
							
						</div>
					</div>

                    <!-- 9. AÇÃO ELIMINADA POR ESTAR VINCULADA A UM PROGRAMA CONCORRENTE NESSA EDITAL -->
                    <div class="row">
                        <div class="col s12">
                            <div class="card-panel">
                                <div class="row">
                                    <h5 class="col s12">Ação eliminada por estar vinculada a um programa concorrente nesse edital?</h5>

                                    <At_acao_eliminada_concorrente v-if="analise_tecnica"
                                                                   :all-disabled="modoTela === 'visualizacao'"
                                                                   :p-validacao-selecionada.sync="analise_tecnica.item_acao_eliminada_vinculada_programa_concorrente"></At_acao_eliminada_concorrente>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- RESULTADO -->
                    <div class="row" v-if="retornaResultadoDaAnaliseTecnica != null">

                        <div class="col s12 blue-grey lighten-5">
                            <p>
                                <i class="material-icons blue-text text-darken-3 left">info</i>

                                <span v-if="retornaResultadoDaAnaliseTecnica === 'eliminado'">Resultado da análise técnica: <strong class="red-text">Eliminada!</strong></span>

                                <span v-else-if="retornaResultadoDaAnaliseTecnica === 'em_exigencia'">Resultado da análise técnica: <strong class="blue-text">Em Exigência!</strong></span>

                                <span v-else>Resultado da análise técnica: <strong class="green-text">Habilitada!</strong></span>

                            </p>
                        </div>
                    </div>

                    <!-- PARECER DO ANALISTA EM CASO DE RESULTADO "ELIMINADO" -->
                    <div class="row" v-if="retornaResultadoDaAnaliseTecnica === 'eliminado' || retornaResultadoDaAnaliseTecnica === 'habilitado'">

                        <div class="col s12">
                            <div class="card-panel">
                                <div class="row">
                                    <h5 class="col s12">Parecer</h5>

                                    <At_parecer_eliminado v-if="analise_tecnica"
                                                          :all-disabled="modoTela === 'visualizacao'"
                                                          :p-parecer-eliminado.sync="analise_tecnica.parecer_eliminado"></At_parecer_eliminado>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- PARECER DO ANALISTA EM CASO DE RESULTADO "EXIGÊNCIA" -->
                    <div class="row" v-if="retornaResultadoDaAnaliseTecnica === 'em_exigencia'">

                        <div class="col s12">
                            <div class="card-panel">
                                <div class="row">
                                    <h5 class="col s12">Especificação das correções necessárias na proposta</h5>

                                    <At_parecer_exigencia v-if="analise_tecnica"
                                                          :all-disabled="modoTela === 'visualizacao'"
                                                          :p-parecer-exigencia.sync="analise_tecnica.especificacao_correcoes_proposta"></At_parecer_exigencia>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="row">
            <div class="col s12">
                <a class="btn-large waves-effect waves-light indigo"
                   :disabled="modoTela === 'visualizacao'"
                   @click.prevent.stop="salvarDados"><i class="material-icons left">save</i>Salvar</a>
            </div>
        </div>
    </section>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import At_participacoes_na_siac from "./at_participacoes_na_siac";
import Dados_inscricao from "./dados_inscricao";
import At_observacoes from "./at_observacoes";
import At_parcerias from "./at_parcerias";
import At_relatorio_bolsista_edital_anterior from "./at_relatorio_bolsista_edital_anterior";
import At_qtd_estudantes_orientados from "./at_qtd_estudantes_orientados";
import At_tempo_existencia_acao from "./at_tempo_existencia_acao";
import At_carga_horaria_evento from "./at_carga_horaria_evento";
import At_relatorio_acao from "./at_relatorio_acao";
import At_relatorio_acao_siga from "./at_relatorio_acao_siga";
import At_acao_eliminada_concorrente from "./at_acao_eliminada_concorrente";
import At_parecer_eliminado from "./at_parecer_eliminado";
import At_parecer_exigencia from "./at_parecer_exigencia";

export default {
    name: "create_or_update",
    provide: function () {
        return {
            principal: this
        }
    },
    components: {
        At_parecer_exigencia,
        At_parecer_eliminado,
        At_acao_eliminada_concorrente,
        At_relatorio_acao,
		At_relatorio_acao_siga,
        At_tempo_existencia_acao,
		At_carga_horaria_evento,
        At_qtd_estudantes_orientados,
        At_relatorio_bolsista_edital_anterior,
        At_observacoes,
        Dados_inscricao,
        At_participacoes_na_siac,
        At_parcerias,
        Loading,
    },
    props: {
        modoTela: {
            type: String,
            default: null,
            required: true,
        },

        csrfToken: {
            type: String,
            default: null,
            required: true,
        },

        routeSaveData: {
            type: String,
            default: null,
            required: true,
        },

        routeList: {
            type: String,
            default: null,
            required: true,
        },

        pParticipacoesNaSiac: {
            type: String,
            default: null,
            required: true,
        },
		
		pTrabalhosNaSiac: {
            type: String,
            default: null,
            required: true,
        },

        pInscricao: {
            type: String,
            default: null,
            required: true
        },

        pUsuarioLogado: {
            type: String,
            default: null,
            required: true
        },

        pConfiguracaoDaAnalise: {
            type: String,
            default: null,
            required: true
        },

        pExibeOpcaoEliminadoParaRelatorioESiac: {
            type: String,
            default: null,
            required: true
        },

        pBolsistasDaAcaoNoEditalAnterior: {
            type: String,
            default: null,
            required: true
        },
    },
    data() {
        return {
            participacoesNaSiac: JSON.parse(this.pParticipacoesNaSiac),
			trabalhosApresentadosNaSiac: JSON.parse(this.pTrabalhosNaSiac),
            inscricao: JSON.parse(this.pInscricao),
            usuarioLogado: JSON.parse(this.pUsuarioLogado),
            configuracaoDaAnalise: JSON.parse(this.pConfiguracaoDaAnalise),
            exibeOpcaoEliminadoParaRelatorioESiac: this.pExibeOpcaoEliminadoParaRelatorioESiac && this.pExibeOpcaoEliminadoParaRelatorioESiac === '1' ? true : (!this.pExibeOpcaoEliminadoParaRelatorioESiac ? false : JSON.parse(this.pExibeOpcaoEliminadoParaRelatorioESiac)),
            analise_tecnica: null,
            bolsistasDaAcaoNoEditalAnterior: this.pBolsistasDaAcaoNoEditalAnterior !== '' && this.pBolsistasDaAcaoNoEditalAnterior != null ? JSON.parse(this.pBolsistasDaAcaoNoEditalAnterior) : [],
            loading: false
		}
    },
    computed: {
        retornaResultadoDaAnaliseTecnica() {
            let resultado = 'habilitado';

            if(!this.analise_tecnica ||
                (
                    this.analise_tecnica.item_relatorio_acao == null
					&& this.analise_tecnica.item_relatorio_acao_siga == null
                    && this.analise_tecnica.item_acao_eliminada_vinculada_programa_concorrente == null
                    && this.analise_tecnica.item_relatorio_de_bolsistas == null
                    && this.analise_tecnica.item_apresentacao_de_trabalho_na_siac == null
                    && this.analise_tecnica.item_acao_possui_parcerias_externas_validacao == null
                )
            ) {
                return null;
            }

            if(this.analise_tecnica.item_relatorio_acao === 'eliminado' ||
                this.analise_tecnica.item_acao_eliminada_vinculada_programa_concorrente === 'eliminado' ||
                this.analise_tecnica.item_relatorio_de_bolsistas === 'eliminado' ||
                this.analise_tecnica.item_apresentacao_de_trabalho_na_siac === 'eliminado')
                resultado = 'eliminado';

            if(resultado !== 'eliminado' && this.analise_tecnica.item_relatorio_de_bolsistas === 'nao_atende'){
                if(this.configuracaoDaAnalise.relatorio_de_bolsistas_nao_atende === 'elimina_imediatamente')
                    resultado = 'eliminado';
                else
                    resultado = 'em_exigencia';
            }

            if(resultado !== 'eliminado' && this.analise_tecnica.item_apresentacao_de_trabalho_na_siac === 'nao_atende'){
                if(this.configuracaoDaAnalise.participacao_na_siac_nao_atende === 'elimina_imediatamente')
                    resultado = 'eliminado';
                else
                    resultado = 'em_exigencia';
            }
			
			if(resultado !== 'eliminado' && this.analise_tecnica.item_relatorio_acao_siga === 'nao_atende'){
               resultado = 'em_exigencia';
            }

            if(resultado !== 'eliminado' && this.analise_tecnica.item_acao_possui_parcerias_externas_validacao === 'em_exigencia')
                resultado = 'em_exigencia';

            return resultado;
        }
    },
    watch: {
        retornaResultadoDaAnaliseTecnica(newValue) {
            if(newValue === 'em_exigencia')
                this.analise_tecnica.parecer_eliminado = null;
            else
                this.analise_tecnica.especificacao_correcoes_proposta = null;

            this.analise_tecnica.resultado = newValue
        }
    },
    methods: {
        inicializaFormularioDeAnaliseTecnica(){
            if(this.inscricao.analise_tecnica != null)
                this.analise_tecnica = this.inscricao.analise_tecnica
            else {
                this.analise_tecnica = {
                    id: null,
                    inscricaos_id: this.inscricao.id,
                    observacoes: null,
                    item_acao_possui_parcerias_externas_validacao: null, //ok, em_exigencia
                    item_acao_possui_parcerias_externas_opcao: null,
                    item_acao_possui_parcerias_externas_pontuacao: null,
                    item_relatorio_de_bolsistas: null, //nao_se_aplica, atende, nao_atende
                    item_apresentacao_de_trabalho_na_siac: null, //nao_se_aplica, atende, nao_atende
                    item_participacoes_na_siac: [],
                    item_participacoes_na_siac_pontuacao: 0,
                    item_quantidade_estudantes_orientados: null,
                    item_quantidade_estudantes_orientados_opcao: null,
                    item_quantidade_estudantes_orientados_pontuacao: null,
                    item_tempo_existencia_acao: null,
                    item_tempo_existencia_acao_opcao: null,
                    item_tempo_existencia_acao_pontuacao: null,
                    item_relatorio_acao: null, //nao_se_aplica, atende, eliminado
                    item_acao_eliminada_vinculada_programa_concorrente: null, //nao, eliminado
                    parecer_eliminado: null,
                    especificacao_correcoes_proposta: null,
                    resultado: null,
                }
            }

            this.analise_tecnica.item_participacoes_na_siac = this.participacoesNaSiac
        },

        validaRegrasAntesDeSalvar(){
            if(this.modoTela === 'analise_exigencias'){
                if(this.analise_tecnica.resultado === 'em_exigencia'){
                    Swal.fire({ title: 'Ação inválida!', text: 'Durante o período de análise das exigências só é permitido salvar uma proposta como HABILITADA ou ELIMINADA.', icon: 'error'})
                    return false;
                }
            }

            return true;
        },

        async salvarDados(){
            if(this.validaRegrasAntesDeSalvar()){
                if(this.modoTela === 'analise_exigencias')
                    this.$set(this.analise_tecnica, 'analise_exigencias', true)

                this.loading = true

                let url = null;

                if(this.analise_tecnica.id == null){
                    url = '/api/analises-tecnicas'

                    await this.$http.post(url, this.analise_tecnica).then(response => {
                        window.location.href = `${this.routeList}/?msg=${response.body.msg}`
                        //Swal.fire('Sucesso!', response.body.msg, 'success')
                    }, error => {
                        if(error.body.hasOwnProperty('validation_errors')){
                            Swal.fire('Ocorreu um erro!', error.body.validation_errors[0], 'error')
                        }else{
                            const exceptionMensagem = _.replace(_.replace(error.body.exception, '#nr1', '<b>'), '#nr2', '</b>')

                            Swal.fire({ title: 'Ocorreu um erro!', html: exceptionMensagem, footer: error.body.msg, icon: 'error'})
                        }
                    })
                }else{
                    url = `/api/analises-tecnicas/${this.analise_tecnica.id}`

                    await this.$http.put(url, this.analise_tecnica).then(response => {
                        window.location.href = `${this.routeList}/?msg=${response.body.msg}`
                        //Swal.fire('Sucesso!', response.body.msg, 'success')
                    }, error => {
                        if(error.body.hasOwnProperty('validation_errors')){
                            Swal.fire('Ocorreu um erro!', error.body.validation_errors[0], 'error')
                        }else{
                            const exceptionMensagem = _.replace(_.replace(error.body.exception, '#nr1', '<b>'), '#nr2', '</b>')

                            Swal.fire({ title: 'Ocorreu um erro!', html: exceptionMensagem, footer: error.body.msg, icon: 'error'})
                        }
                    })
                }

                this.loading = false
            }
        },

        setPontuacaoDeParticipacoesNaSiac(pontuacao){
            this.analise_tecnica.item_participacoes_na_siac_pontuacao += pontuacao

            if(this.analise_tecnica.item_participacoes_na_siac_pontuacao >= this.configuracaoDaAnalise.participacao_na_siac_maximo_pontos)
                this.analise_tecnica.item_participacoes_na_siac_pontuacao = this.configuracaoDaAnalise.participacao_na_siac_maximo_pontos
        },
    },
    mounted() {
        this.inicializaFormularioDeAnaliseTecnica();
	},
	
}
</script>

<style scoped>

</style>
